import React from 'react';

import { Button } from 'antd';
import { t } from 'i18next';

interface Props {
  handleCancel: () => void;
  resetFields?: () => void;
}

export const ModalFooter = ({ resetFields, handleCancel }: Props) => (
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <Button style={{ width: `${resetFields ? '48%' : '100%'}` }} danger onClick={handleCancel}>
      {t('user.cancel', 'Отмена')}
    </Button>
    {
      resetFields
        && (
          <Button
            style={{ width: '48%' }}
            className="filter-form__button"
            onClick={() => {
              resetFields();
            }}
          >
            {t('user.reset', 'Сбросить')}
          </Button>
        )
    }
  </div>
);
